import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import message from 'antd/lib/message'
import { isMobile } from 'react-device-detect'

import { apiManager } from 'helpers'

const SocialAccountCallback = () => {
  const { platform } = useParams()
  const { search } = useLocation()

  useEffect(() => {
    const searchParams = new URLSearchParams(search)
    const code = searchParams.get('code')
    const state = searchParams.get('state')
    const error = searchParams.get('error')

    const onComplete = () => {
      if (isMobile) {
        window.location.replace('/settings')
      } else {
        window.close()
      }
    }

    const showError = errorMessage => {
      message.error(errorMessage || 'Unable to link account, please try again')

      setTimeout(onComplete, 2000)
    }

    if (error) {
      return showError()
    }

    const verifyAccount = async ({ code, state }) => {
      const data = {
        code,
        state,
        platform,
      }

      try {
        await apiManager.verifySocialAccount(data)
        onComplete()
      } catch (error) {
        showError(error?.message)
      }
    }

    verifyAccount({ code, state })
  }, [search, platform])

  return null
}

export default SocialAccountCallback
